import "core-js/modules/es.number.constructor.js";
import { useGetTranslations } from '~/composables/useGetTranslations';
export default defineComponent({
  name: 'HowToUseRank',
  props: {
    level: Number
  },
  setup: function setup(props) {
    var _useGetTranslations = useGetTranslations(),
      translate = _useGetTranslations.translate;
    var levelDescription = "eolp.howToUseRank".concat(props.level || 0, "Label");
    var MAX_LEVELS = 3;
    return {
      translate: translate,
      levelDescription: levelDescription,
      MAX_LEVELS: MAX_LEVELS
    };
  }
});